import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=f14283ce&scoped=true&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=f14283ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14283ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
